import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PaginatedItems from "./PaginatedItems";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  dodaqBg,
  filter,
  glitterBg,
  highlighterBg,
  kiprikBg,
  makyajAletleriBg,
  makyajTemizleyiciBg,
  mukemmelBitirisKolleksiyasiBg,
  productBg,
  professionalBg,
  qasSabitleyiciBg,
  titleIcon3,
  titleIcon4,
  tonalKremBg,
  transparanPudraBg,
} from "../../assets/images";
import { Helmet } from "react-helmet";

const Products = () => {
  const { t, i18n } = useTranslation();
  const [products, setProducts] = useState([]);
  const [activeFilters, setActiveFilters] = useState({});
  const [searchValues, setSearchValues] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const navigation = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [allCategories, setCategories] = useState([]);
  const [categoryFilters, setCategoryFilters] = useState([]);
  const [productFilterOptions, setProductFilterOptions] = useState([]);
  const currentLanguage = i18n.language;
  const [single, setSingle] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const category = searchParams.get("categories");

  useEffect(() => {
    getProducts();
    getCategories();
    getProductFilterOptions();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    // Tüm filtre parametrelerini al
    const filtersFromURL = {};
    queryParams.forEach((value, key) => {
      if (key !== "categories") {
        filtersFromURL[key] = value.split(",");
      }
    });

    setActiveFilters(filtersFromURL);
  }, [location.search]);

  useEffect(() => {
    // Kategori değiştiğinde filtreleri yükle
    if (category && allCategories.length > 0) {
      loadCategoryFilters(category);
    } else {
      setCategoryFilters([]);
    }
  }, [category, allCategories]);

  const getBackgroundImage = (category) => {
    switch (category) {
        case "Kirpiklər":
        return kiprikBg; 
        case "Qaş sabitləyici":
        return qasSabitleyiciBg; 
        case "Makyaj təmizləyici vasitələr":
        return makyajTemizleyiciBg; 
        case "Glitter":
        return glitterBg;  
        case "Tonal krem":
        return tonalKremBg;  
         case "Makyaj alətləri":
        return makyajAletleriBg;  
        case "Dodaq Boyaları":
        return dodaqBg;  
         case "Transparan pudra":
        return transparanPudraBg;  
         case "Mükəmməl Bitiriş Kolleksiyası":
        return mukemmelBitirisKolleksiyasiBg;  
         case "Highlighter":
        return highlighterBg;  
      default:
        return productBg;
    }
  };

  const backgroundImage = getBackgroundImage(category);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/dashboard.php`,
        { withCredentials: false }
      );
      setProducts(response.data.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getCategories = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/categories.php`,
        { withCredentials: false }
      );
      setCategories(response.data.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getProductFilterOptions = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/product_filter_options.php`,
        { withCredentials: false }
      );

      if (response.data.status === 1) {
        setProductFilterOptions(response.data.data);
      } else {
        console.error("API error:", response.data.message);
        // Hata durumunda boş array kullan
        setProductFilterOptions([]);
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching product filter options:", error);
      // Hata durumunda boş array kullan
      setProductFilterOptions([]);
      setIsLoading(false);
    }
  };

  const loadCategoryFilters = (categoryName) => {
    const category = allCategories.find(
      (cat) =>
        cat.name === categoryName ||
        cat.nameEn === categoryName ||
        (cat.nameRu && cat.nameRu === categoryName)
    );

    if (category && category.filters) {
      setCategoryFilters(category.filters);
    } else {
      setCategoryFilters([]);
    }
  };

  const handleFilterChange = (filterId, value) => {
    setActiveFilters((prev) => {
      const currentValues = prev[filterId] || [];
      let newValues;

      if (currentValues.includes(value)) {
        newValues = currentValues.filter((v) => v !== value);
      } else {
        newValues = [...currentValues, value];
      }

      const updatedFilters = {
        ...prev,
        [filterId]: newValues,
      };

      // Boş array'leri kaldır
      Object.keys(updatedFilters).forEach((key) => {
        if (updatedFilters[key].length === 0) {
          delete updatedFilters[key];
        }
      });

      updateURLFilters(updatedFilters);
      return updatedFilters;
    });
  };

  const updateURLFilters = (filters) => {
    const queryParams = new URLSearchParams();

    if (category) {
      queryParams.set("categories", category);
    }

    Object.keys(filters).forEach((key) => {
      if (filters[key].length > 0) {
        queryParams.set(key, filters[key].join(","));
      }
    });

    navigation({ search: queryParams.toString() });
  };

  const clearFilter = (filterId) => {
    setActiveFilters((prev) => {
      const newFilters = { ...prev };
      delete newFilters[filterId];
      updateURLFilters(newFilters);
      return newFilters;
    });

    // Arama değerini de sıfırla
    setSearchValues((prev) => ({
      ...prev,
      [filterId]: "",
    }));
  };

  const clearAllFilters = () => {
    setActiveFilters({});
    setSearchValues({});

    const queryParams = new URLSearchParams();
    if (category) {
      queryParams.set("categories", category);
    }

    navigation({ search: queryParams.toString() });
  };

  const filteredProducts = products.filter((product) => {
    // Kategori filtrelemesi
    if (category) {
  // Ürünün kategorisini bul
  const productCategory = allCategories.find(
    (cat) => cat.id == product.category_id
  );

  // Eğer ürünün kategorisi varsa ve adı URL'deki kategoriyle eşleşmiyorsa
  if (
    productCategory &&
    productCategory.name !== category &&
    productCategory.nameEn !== category &&
    productCategory.nameRu !== category
  ) {
    return false;
  }
}


    // Dinamik filtreleme - product_filter_options tablosuna göre
    for (const filterId in activeFilters) {
      const filterValues = activeFilters[filterId];

      // Bu ürünün filtre seçeneklerini bul
      const productFilterOptionIds = productFilterOptions
        .filter((pfo) => pfo.product_id == product.id)
        .map((pfo) => pfo.filter_option_id.toString());

      // Filtre değerlerinden en az biri ürünün filtre seçeneklerinde olmalı
      const hasMatch = filterValues.some((value) =>
        productFilterOptionIds.includes(value)
      );

      if (!hasMatch) {
        return false;
      }
    }

    return true;
  });

  const handleSearchChange = (filterId, value) => {
    setSearchValues((prev) => ({
      ...prev,
      [filterId]: value,
    }));
  };

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  };

  const getFilteredOptions = (filter) => {
    const searchValue = searchValues[filter.id] || "";
    if (!searchValue) return filter.options;

    return filter.options.filter((option) =>
      option.value.toLowerCase().includes(searchValue.toLowerCase())
    );
  };

  // Filtre seçeneklerini ve ürün sayılarını hesapla
  const getOptionCounts = (filterId) => {
    const counts = {};

    // Her bir filtre seçeneği için ürün sayısını hesapla
    const filterOptions =
      categoryFilters.find((f) => f.id == filterId)?.options || [];

    filterOptions.forEach((option) => {
      // Bu filtre seçeneğine sahip ürünleri say
      const productCount = products.filter((product) => {
        // Kategori kontrolü
        if (category && product.category !== category) return false;

        // Diğer aktif filtrelerle eşleşen ürünleri bul
        for (const otherFilterId in activeFilters) {
          if (otherFilterId != filterId) {
            const otherFilterValues = activeFilters[otherFilterId];
            const productHasOtherFilter = productFilterOptions.some(
              (pfo) =>
                pfo.product_id == product.id &&
                otherFilterValues.includes(pfo.filter_option_id.toString())
            );

            if (!productHasOtherFilter && otherFilterValues.length > 0) {
              return false;
            }
          }
        }

        // Bu filtre seçeneğine sahip mi kontrol et
        return productFilterOptions.some(
          (pfo) =>
            pfo.product_id == product.id && pfo.filter_option_id == option.id
        );
      }).length;

      counts[option.id] = productCount;
    });

    return counts;
  };

  return (
    <>
      {single && ( 
        <Helmet>
          <title>{getLocalizedField(single, "meta_tag_title")}</title>
          <meta
            name="description"
            content={getLocalizedField(single, "meta_tag_description")}
          />
          <meta
            name="keywords"
            content={getLocalizedField(single, "meta_tag_keywords")}
          />
        </Helmet>
      )}

      <div>
        <div className="max-w-containerSm md:max-w-container mx-auto">
        <div className="mt-10">
  <div
    style={{
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: window.innerWidth < 640 ? "288px" : "344px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      borderRadius: "4px",
      position: "relative",
      overflow: "hidden",
    }}
  >
    {/* OPACITY QATI */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "rgba(0, 0, 0, 0.2)", // rəngi daha qaranlıq etmək üçün 0.6 edə bilərsən
        zIndex: 1,
      }}
    />

    {/* MƏTN BLOKU */}
    <div style={{ position: "relative", zIndex: 2 }} className="flex flex-col items-center">
      <div className="flex items-center">
        <img className="w-[50px] h-auto mr-2" src={titleIcon3} alt="Icon" />
        <p className="text-center text-[24px] md:text-[32px] font-semibold text-white">
          {category ? t(category) : t("Bütün Məhsullar")}
        </p> 
        <img className="w-[50px] h-auto ml-2" src={titleIcon4} alt="Icon" />
      </div>

      <p className="text-center text-white text-[14px] md:text-[16px] mt-3 md:w-[460px]">
        {t(
          "Bütün kateqoriyalar üzrə ən son təqdim etdiyimiz məhsullarla tanış olun"
        )}
      </p>
    </div>
  </div>
</div>


          <div className="md:flex max-w-containerSm md:max-w-container mx-auto mt-14 justify-between">
            <button
              className="md:hidden my-6 border-[1px] border-[#CFCFCF] w-full h-[44px] rounded-2xl px-5 flex justify-between items-center"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span>{t("Filter")}</span>
              <img className="h-6 w-6" src={filter} alt="Filter" />
            </button>

            {isOpen && (
              <div className="fixed top-0 left-0 w-full h-full bg-white z-50 p-4 overflow-auto shadow-lg ">
                <button
                  onClick={() => setIsOpen(false)}
                  className="absolute top-4 right-4 text-lg font-bold"
                >
                  ✖
                </button>

                <div className="w-full mx-auto mt-8">
                  {/* Dinamik Filtreler */}
                  {categoryFilters.map((filter) => {
                    const optionCounts = getOptionCounts(filter.id);
 
                    return (
                      <div key={filter.id} className="mt-6">
                        <div className="bg-[#F9FAFB] border border-[#CFCFCF] p-4 rounded-xl">
                          <label className="text-[#393941] font-semibold">
                            {getLocalizedField(filter, "name")}
                          </label>
                        </div> 

                        <div className="bg-[#F9FAFB] border border-[#CFCFCF] p-4 rounded-xl mt-2">
                          <div className="relative w-full">
                            <svg
                              className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M21 21l-4.35-4.35m1.85-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
                              />
                            </svg>
                            <input
                              type="text"
                              placeholder={t("Axtarın")}
                              value={searchValues[filter.id] || ""}
                              onChange={(e) =>
                                handleSearchChange(filter.id, e.target.value)
                              }
                              className="w-full pl-10 pr-4 border rounded-lg h-[40px] border-[#E7E7E7] focus:outline-none"
                            />
                          </div>

                          <div className="flex flex-col mt-2 max-h-48 overflow-y-auto space-y-2">
                            {getFilteredOptions(filter).map((option) => (
                              <div
                                key={option.id}
                                className="flex justify-between items-center"
                              >
                                <div>
                                  <input
                                    type="checkbox"
                                    id={`option-${option.id}`}
                                    checked={(
                                      activeFilters[filter.id] || []
                                    ).includes(option.id.toString())}
                                    onChange={() =>
                                      handleFilterChange(
                                        filter.id,
                                        option.id.toString()
                                      )
                                    }
                                    className="accent-[#162D59] h-6 w-6 relative top-[6px]"
                                  />
                                  <label
                                    htmlFor={`option-${option.id}`}
                                    className="ml-2 text-firstColor text-[14px]"
                                  >
                                    {getLocalizedField(option, "value")}
                                  </label>
                                </div>
                                <span className="text-sm text-gray-500">
                                  ({optionCounts[option.id] || 0})
                                </span>
                              </div>
                            ))}
                          </div>

                          <button
                            onClick={() => clearFilter(filter.id)}
                            className="mt-[10px] w-full py-3 border-t-[1px] border-[#CFCFCF] text-[#162D59]"
                          >
                            {t("Seçimləri ləğv et")}
                          </button>
                        </div>
                      </div>
                    );
                  })}

                  {Object.keys(activeFilters).length > 0 && (
                    <button
                      onClick={clearAllFilters}
                      className="mt-6 w-full py-3 bg-[#162D59] text-white rounded-xl"
                    >
                      {t("Bütün filtrləri təmizlə")}
                    </button>
                  )}
                </div>
              </div>
            )}

            {categoryFilters && categoryFilters.length > 0 && (
              <div className="md:w-[273px] hidden md:block">
                {/* Dinamik Filtreler */}
                {categoryFilters.map((filter) => {
                  const optionCounts = getOptionCounts(filter.id);

                  return (
                    <div key={filter.id} className="mt-6">
                      <div className="bg-[#F9FAFB] border border-[#CFCFCF] p-4 rounded-xl">
                        <label className="text-[#393941] font-semibold">
                           {getLocalizedField(filter, "name")}
                        </label>
                      </div>

                      <div className="bg-[#F9FAFB] border border-[#CFCFCF] p-4 rounded-xl mt-2">
                        <div className="relative w-full">
                          <svg
                            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M21 21l-4.35-4.35m1.85-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                          </svg>
                          <input
                            type="text"
                            placeholder={t("Axtarın")}
                            value={searchValues[filter.id] || ""}
                            onChange={(e) =>
                              handleSearchChange(filter.id, e.target.value)
                            }
                            className="w-full pl-10 pr-4 border rounded-lg h-[40px] border-[#E7E7E7] focus:outline-none"
                          />
                        </div>

                        <div className="flex flex-col mt-2 max-h-48 overflow-y-auto space-y-2">
                          {getFilteredOptions(filter).map((option) => (
                            <div
                              key={option.id}
                              className="flex justify-between items-center"
                            >
                              <div>
                                <input
                                  type="checkbox"
                                  id={`option-${option.id}`}
                                  checked={(
                                    activeFilters[filter.id] || []
                                  ).includes(option.id.toString())}
                                  onChange={() =>
                                    handleFilterChange(
                                      filter.id,
                                      option.id.toString()
                                    )
                                  }
                                  className="accent-[#162D59] h-6 w-6 relative top-[6px]"
                                />
                                <label
                                  htmlFor={`option-${option.id}`}
                                  className="ml-2 text-firstColor text-[14px]"
                                >
                                 {getLocalizedField(option, "value")}
                                </label>
                              </div>
                              <span className="text-sm text-gray-500">
                                ({optionCounts[option.id] || 0})
                              </span>
                            </div>
                          ))}
                        </div>

                        <button
                          onClick={() => clearFilter(filter.id)}
                          className="mt-[10px] w-full py-3 border-t-[1px] border-[#CFCFCF] text-[#162D59]"
                        >
                          {t("Seçimləri ləğv et")}
                        </button>
                      </div>
                    </div>
                  );
                })}

                {Object.keys(activeFilters).length > 0 && (
                  <button
                    onClick={clearAllFilters}
                    className="mt-6 w-full py-3 bg-[#162D59] text-white rounded-xl"
                  >
                    {t("Bütün filtrləri təmizlə")}
                  </button>
                )}
              </div>
            )}

            <div
              className={`mt-6 ${
                categoryFilters && categoryFilters.length > 0
                  ? "md:w-[985px]"
                  : "w-full"
              }`}
            >
              {isLoading ? (
                <p className="text-white">Loading...</p>
              ) : (
                <>
                  {Object.keys(activeFilters).length > 0 && (
                    <div className="mb-4 p-3 bg-gray-100 rounded-lg">
                      <span className="font-semibold">
                        {t("Aktiv filtrlər")}:{" "}
                      </span>
                      {Object.entries(activeFilters).map(
                        ([filterId, values]) => {
                          const filter = categoryFilters.find(
                            (f) => f.id == filterId
                          );
                          if (!filter) return null;

                          return values.map((value) => {
                            const option = filter.options.find(
                              (o) => o.id == value
                            );
                            if (!option) return null;

                            return (
                              <span
                                key={`${filterId}-${value}`}
                                className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-md ml-2"
                              >
                                {getLocalizedField(filter, "name")}: {getLocalizedField(option, "value")}
                                <button
                                  onClick={() =>
                                    handleFilterChange(filterId, value)
                                  }
                                  className="ml-1 text-blue-600 font-bold"
                                >
                                  ×
                                </button>
                              </span>
                            );
                          });
                        }
                      )}
                      <button
                        onClick={clearAllFilters}
                        className="ml-3 text-red-600 text-sm underline"
                      >
                        {t("Hamısını təmizlə")}
                      </button>
                    </div>
                  )}

                  <PaginatedItems itemsPerPage={12} items={filteredProducts} />

                  {filteredProducts.length === 0 && !isLoading && (
                    <div className="text-center py-10">
                      <p className="text-gray-500 text-lg">
                        {t("Seçdiyiniz filtrlərə uyğun məhsul tapılmadı")}
                      </p>
                      <button
                        onClick={clearAllFilters}
                        className="mt-4 px-4 py-2 bg-[#162D59] text-white rounded-md"
                      >
                        {t("Filterləri təmizlə")}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
